import { createRoot } from 'react-dom/client';
import App from './global/App';
const container = document.getElementById('rootPage');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<App tab="home" />);